import React from 'react';
import Footer from '../../components/Footer';

const EFFECTIVE_DATE = '12 April 2026';

function TermsPage() {
  return (
    <main className="doc-page">
      <div className="doc-container">
        <div className="doc-header">
          <h1 className="doc-title">Terms of Service</h1>
          <p className="doc-date">Effective Date: {EFFECTIVE_DATE}</p>
        </div>

        <div className="doc-body">
          <p>
            Welcome to Hold On. By using our app, you agree to the following terms. If you
            don't agree, don't use the app.
          </p>

          <section className="doc-section">
            <h2><span className="section-num">1.</span> Use of the App</h2>
            <p>
              Hold On is an iOS application that helps users reduce screen time on social media
              apps by showing intervention nudges when they approach or exceed their daily usage
              limits. It uses Apple's Screen Time API (FamilyControls and DeviceActivity
              frameworks) to monitor usage and display overlays.
            </p>
            <p>
              You may only use the app for its intended purpose. Any misuse, including attempts to
              bypass or manipulate its screen time features, is prohibited.
            </p>
          </section>

          <section className="doc-section">
            <h2><span className="section-num">2.</span> No Account Required</h2>
            <p>
              You are not required to create an account to use Hold On. All data is stored locally
              on your device. There is no backend, no user account, and no network calls beyond the
              third-party services listed below.
            </p>
          </section>

          <section className="doc-section">
            <h2><span className="section-num">3.</span> Subscriptions &amp; Payments</h2>
            <p>
              The app is free to download. A paid subscription is required to access Pro features,
              including multi-app tracking, Vacation Days, and the Weekly Report. The annual plan
              includes a 7-day free trial, a payment method is required to start it, and you will
              be charged automatically when the trial ends unless you cancel first. The monthly plan
              has no free trial. Payments are processed through Apple's App Store.
            </p>
            <p>
              All purchases are final. We do not offer refunds, except as required by applicable
              law or Apple's own policies.
            </p>
          </section>

          <section className="doc-section">
            <h2><span className="section-num">4.</span> Screen Time &amp; FamilyControls</h2>
            <p>
              Hold On uses Apple's FamilyControls entitlement to monitor app usage and display
              nudge overlays on selected social media apps. This permission is required for core
              functionality. We do not use this access for any purpose other than delivering nudges
              as described in the app.
            </p>
          </section>

          <section className="doc-section">
            <h2><span className="section-num">5.</span> Third-Party Services</h2>
            <p>
              We use PostHog to collect anonymized analytics data to understand how users interact
              with the app. This includes onboarding funnel completion, feature usage, and paywall
              conversion. No personally identifiable information is transmitted. Data is never sold
              or shared with third parties for advertising.
            </p>
            <p>All subscription payments are processed through Apple's App Store.</p>
          </section>

          <section className="doc-section">
            <h2><span className="section-num">6.</span> Restrictions</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Use the app for unlawful or unintended purposes.</li>
              <li>
                Reverse engineer, tamper with, or attempt to circumvent its nudge or screen time
                features.
              </li>
              <li>Exploit bugs or errors in the app.</li>
            </ul>
            <p>
              We reserve the right to restrict access if the app is used in ways that violate
              these terms.
            </p>
          </section>

          <section className="doc-section">
            <h2><span className="section-num">7.</span> Age Requirement</h2>
            <p>
              Hold On is intended for users aged 13 and above. Parents and guardians are
              responsible for supervising use by minors.
            </p>
          </section>

          <section className="doc-section">
            <h2><span className="section-num">8.</span> Disclaimer &amp; Limitation of Liability</h2>
            <p>
              The app is provided "as is" without warranties of any kind. We make no guarantees
              regarding its effectiveness in reducing screen time, availability, or uninterrupted
              operation.
            </p>
            <p>
              To the fullest extent permitted by law, we are not liable for any indirect,
              incidental, or consequential damages resulting from your use of Hold On.
            </p>
          </section>

          <section className="doc-section">
            <h2><span className="section-num">9.</span> Changes to the Terms</h2>
            <p>
              We may update these Terms from time to time. Continued use of the app after changes
              go into effect constitutes your acceptance of the revised Terms.
            </p>
          </section>

          <section className="doc-section">
            <h2><span className="section-num">10.</span> Contact</h2>
            <p>
              If you have any questions about these Terms, please contact us at:{' '}
              <a href="mailto:getholdonapp@gmail.com" className="doc-link">getholdonapp@gmail.com</a>
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </main>
  );
}

export default TermsPage;
